module.exports = __webpack_public_path__ + "img/logo-2.0e24469d.svg";